// Local assets store meant to keep icons till they appear in Cosmos
// if there are no intensions to keep them there, use icons as components' local resources

import AppBadge from './assets/app-badge.svg';
import IconTwitter from './assets/icon-twitter.svg';
import IconInstagram from './assets/icon-instagram.svg';
import IconLinkedin from './assets/icon-linkedin.svg';
import IconFacebook from './assets/icon-facebook.svg';
import Logo from './assets/logo.svg';

type AssetsStoreLocalProps = {
    'app-badge': typeof AppBadge;
    'logo-big': typeof Logo;
    'icon-linkedin': typeof IconLinkedin;
    'icon-twitter': typeof IconTwitter;
    'icon-instagram': typeof IconInstagram;
    'icon-facebook': typeof IconFacebook;
};

const AssetsStoreLocal: AssetsStoreLocalProps = {
    'app-badge': AppBadge,
    'logo-big': Logo,
    'icon-linkedin': IconLinkedin,
    'icon-instagram': IconInstagram,
    'icon-twitter': IconTwitter,
    'icon-facebook': IconFacebook,
};

export default AssetsStoreLocal;
